export const CHANGE_TYPES = {
  FILTER: "filter",
  INITIALIZE: "initialize",
  QUERY: "query",
};
